export default {
    isInaugurationSection() { },

    isBasicSection() { },
};
